"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummonedEffectHandler = exports.SummonedEffectArgs = void 0;
const _1 = require(".");
const __1 = require("../../..");
const Duration_1 = require("../../Duration");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const IdArray_1 = require("../../utils/IdArray");
const EffectType_1 = require("../EffectType");
// This effect is really just a marker effect for any summoned/conjured companions
class SummonedEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.Summoned;
        this.__typeName = "Summoned";
        this.name = "Summoned";
        this.harmful = false;
    }
}
exports.SummonedEffectArgs = SummonedEffectArgs;
let SummonedEffectHandler = class SummonedEffectHandler {
    apply(sequence, container, state) {
        state.meta.watchSummonerDeathHandlerId = container.registerEventHandler(state.creatorId, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), new __1.CancelEffectsEventHandlerArgs([state.id]));
        state.meta.unsummonOnDeathHandlerId = container.registerEventHandler(state.targetId, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), new __1.CancelEffectsEventHandlerArgs([state.id]));
    }
    remove(sequence, container, state) {
        container.cancelEventHandler(state.meta.watchSummonerDeathHandlerId);
        container.cancelEventHandler(state.meta.unsummonOnDeathHandlerId);
        if (!container.isDeceased(state.targetId)) {
            container.applyEffect(sequence, state.targetId, state.targetId, new _1.DeathEffectArgs(), Duration_1.Duration.Permanent);
        }
        (0, IdArray_1.removeElement)(container.getActor(state.creatorId).companionIds, state.targetId);
        container.disableActor(sequence, state.targetId);
    }
};
SummonedEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Summoned)
], SummonedEffectHandler);
exports.SummonedEffectHandler = SummonedEffectHandler;
